// generated by serveWeb or buildWeb script
export const version = '4.0.3';
export const gitBranch = 'staging';
